function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "btn_back");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Fordypningsskjermer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "06_artikkelmal",
  transform: "translate(-66.000000, -60.000000)",
  fill: "#F0AB00",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "btn_back",
  transform: "translate(66.000000, 60.000000)"
}, React.createElement("path", {
  d: "M24.2209259,0.867265945 C23.7068194,0.328212218 23.0006397,0.0164710031 22.2577661,0.00063409807 C21.5148925,-0.0152028069 20.7961894,0.266162133 20.2597917,0.782820752 L0.863120883,19.4677272 C0.311759499,19.9986381 0,20.7327106 0,21.5000415 C0,22.2673724 0.311759499,23.0014449 0.863120883,23.5323558 L20.2597917,42.2172623 C21.376836,43.2930407 23.1502962,43.2552333 24.2209259,42.1328171 C25.2915556,41.0104009 25.2539291,39.2284121 24.1368848,38.1526336 L6.85244531,21.5000415 L24.1368848,4.84744939 C24.6733586,4.33087055 24.9836078,3.62129479 24.9993689,2.87484867 C25.01513,2.12840255 24.7351117,1.40624321 24.2209259,0.867265945 Z",
  id: "Shape"
}))));

var SvgBtnBack = function SvgBtnBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "43px",
    viewBox: "0 0 25 43",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBtnBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-back.b53dbdd1.svg";
export { ForwardRef as ReactComponent };